import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Install from './pages/Install';
import { initAllAnimations } from './utils/animations';

function App() {
  useEffect(() => {
    // Initialize all animations when component mounts
    initAllAnimations();
  }, []);

  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/install" element={<Install />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;